import Config from '@/config'
import AMapLoader from '@amap/amap-jsapi-loader';
import {formatDistance, formatDuration} from '@/libs/util';

let isLoadMap = false;

function loadMap(callback) {
    AMapLoader.load({
        'key': Config.mapKey,
        'version': '2.0',
        'plugins': []
    }).then(() => {
        callback();
    });
}

function geoLocation(callback) {
    AMap.plugin('AMap.Geolocation', function () {
        new AMap.Geolocation({
            enableHighAccuracy: true,
            timeout: 30000
        }).getCurrentPosition(function (status, result) {
            if (status === 'complete') {
                callback(result.position.lng, result.position.lat);
            }
        });
    });
}

function route(origin, destination, callback) {
    AMap.plugin('AMap.Driving', function () {
        new AMap.Driving({policy: AMap.DrivingPolicy.LEAST_TIME,})
            .search([origin.longitude, origin.latitude], [destination.longitude, destination.latitude], function (status, result) {
                if (status === 'complete' && result.routes && result.routes[0] && result.routes[0].distance) {
                    callback(formatDistance(result.routes[0].distance), formatDuration(result.routes[0].time));
                }
            });
    });
}

export const location = (callback) => {
    if (isLoadMap) {
        geoLocation(callback);
    } else {
        loadMap(function () {
            geoLocation(callback);
        });
    }
};

export const drivingRoute = (origin, destination, callback) => {
    if (isLoadMap) {
        route(origin, destination, callback);
    } else {
        loadMap(function () {
            route(origin, destination, callback);
        });
    }
};
